const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const CreateCorrectiveActionMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QGMBOYCGAXMBaZA9quslgJYBueGpZBAdgHRkQA2YAxAMoAqAggCUeAbQAMAXUSgADgVhlyDKSAAeiXACYAjADZGAdn0AWfRv2iAHAGYArEYsBOADQgAnuv2PGFnVYfGtCy0bSwcAXzCXNEwcfCIScipcGkUmFMpOAFUABQARPh4AUQB9ACFCwUKBYp4AeQBpQoA5MUkkEFl5VOU1BFw-B0ZgxwsLUX0Hfy0rF3cELQX9bwcNBytDHQcbDVGIqPRsPEJiMFok9IZGdKpGSAUAAmOEjPuL+g4AYQEKotblToUdHoPXUWkGdh0RlEZh0YyCYxss0QJj0DnGWg0NnWGh0+k2Rj2IGihziJzO1Fol2uYFuEAeT1OiTAr0p7z4pT4TVytSaxW+AEVMoVeIVcn92gDuu1erhIYwjEYrBZFTpRCYoVp9Ei+ji9DocaIsdC-KIHATIkSDrEGeTkqyruTafT4oyXm8OOzOdzeQKhSKxVo2jI5IClNLEFooYwHBZtqI-IYzZiNNrcBjRIwdCENFZNcF9LoJoTidaXba3g6mU6sI8y0yWakOLlhV8AJLZHitnnFD4ACU5AHFReLg10gSC+kZfIwDY4MfoQjpAoi3KCrEZvMZRLogpYbFti1ajnWMnbUpWMtXa2T6+7eAVMlwe-2mkOxRJ-iGpaAZQqtJn9RsYwglWIw1iMbU1kzUwFk2ICtihfRDxiY8b1PCtqSvG1b1ZJtagAWT4VteS4QoABlCg+Ip3yDDov3HcNJyMGxGG3MxRB0JcoVNYxUxMDMAhsfdbGY0JkJJbD0PtTC7hrSSqAbIEOGyARalKCj8OKe8inw5oeGfQdhw-CV6LDH91DApZTVVKF12CYTUysTjMysDQcVjSErCcjRxNLNDzmkx1ZOvZ4FPdVTan0j4+EfEo+0MmjPzHMzVAs-UZ0cBcYwcBZbCxVNMX-ZVMQmDQwJ2fxfNQ0KKXPGS6Tkk8wtwl9cgo6oeAATWyOKXzfEc6OS4FGNwKcNFY6x4LRNysynVNI0YRdjCMBZtEhNyLCq0karPIELxuYL5OZd1CgADWyVsBAKLteXyIotPIyjqIGyUGPMycgkW0RQk47cHH1BVtW0QZ9FzQJQcCEYFS2o7dqpIKGpC11msbD5agEb4qNbAA1Eo+Cx7suFqTIBA+EpSIoqijNo16UplbZwSxec7BWnEtG1Vyli86ZHB2GxrHjJCLRLarkdqvb6udfzjtwtGMaenG8YJ3kVK7ARWy6h7Kee4zR1DYb3twLErCGBZIycjUgm1BVxoXISC0mQxjBhprxfhqsRaR8lFIYDgIAYGkyHoCgCAAaxpEXtrFuH6Be0yDdSnUlgsVZMRsYIY2sRVtQmFjNVVEJM98XEXelmP9ojo8vZwxswGIIhGGkVhsAAMyIABbRhI9ht446Gid+iAoYNn1AYYy0Q1tSzJYC0xMDJkmTLS52jCgvr1AOG+HgBE6vv9YHqcM0xb61XTnYVRXOYJgzBYQkjdOVm0c19hQqPy0Cqs69QIhPjI2pSL3t+ROsoVqLS2MtM+gEUyrgQLZIYK0bBZi2G5dcZpl7R1Xh7BgLcyCoHbq8AARhgeg-t3jRSaGTMixRPRch5IAt6idtDjRND4IwbkcoLkCNqTUBh4z2HMGMNYE9KrCyPG-Jk5dMKEHoDgvBhDiGkM+DyAAYpdTSNDvT0LpsiNyjAlQTGYqDMY2gLCOVVAYUYqxNSGlsLoZ+lpX49w-peWAABXZAyA4CwF-v-QoWiE4ykhP+fcQEwRjH1IaLUMDr6m0LtCaExifKEnoAQCAcBlDd1djHJK+8RqwnBOAhUkDkypmynomMlhQb8JMELF+EkskVhYOwHJQDej7gMKYLMlhp4YnsKU6EM4J7KmhJqVy650HvzquSFpDD6afTNubSE24rYwKNkPFYow7BOTzCXURjiGnOIOojI6PsE60wCeocaiCEy+DhLiFa-0+IbjRLGV5qpQY7GVBMiRmDLyexOW8GZ2i+j-T0bmLyPFvqakcFPHMQxxjQkmKaTEsZvlSSmZ-deQKLmTnTtGKw0JLL8yzOsKeQloxTlxBCIJPg0UBQxX87BuD8EYCISQlK5yJwKgzPbXwZU4JQmcKshU0Y9xvPGK5UY9jMll1+TcNxHivHYonDiTMIQFTMT8CtAspiYH-RNqMcwZtRjKn5hECIQA */
    id: "create-corrective-action",

    predictableActionArguments: true,

    context: {
      authentication: {
        token: null,
      },
      qmsToolApiUrl: null,
    },

    states: {
      idle: {
        on: {
          START: {
            target: "active",
            cond: "validStartRequest",
            actions: ["saveStartRequest", "unflagChanges", "resetChangeSet"],
          },
        },
      },

      active: {
        on: {
          UPDATE_BEARER_TOKEN: {
            target: "active",
            internal: true,
            cond: "validToken",
            actions: "saveToken",
          },
        },
        states: {
          "edit corrective action": {
            on: {
              CREATE: {
                target: "create corrective action",
                cond: "validChangeSet",
              },

              ABANDON_REQUESTED: [
                {
                  target: "#create-corrective-action.idle",
                  cond: "noChanges",
                },
                "confirm abandon",
              ],

              DESCRIPTION_CHANGED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveDescription",
              },

              STATUS_CHANGED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveStatus",
              },

              DOMAIN_SELECTED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveDomain",
              },

              PROBLEM_STATEMENT_CHANGED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveProblemStatement",
              },

              ROOT_CAUSE_CHANGED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveRootCause",
              },

              EXPIRATION_DATE_SELECTED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveExpirationDate",
              },

              CORRECTIVE_ACTION_SOURCE_SELECTED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveCorrectiveActionSource",
              },

              CORRECTIVE_ACTION_PRIORITY_SELECTED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveCorrectiveActionPriority",
              },

              HANDLER_TYPE_CHANGED: {
                target: "edit corrective action",
                internal: true,
                actions: "saveHandlerType",
              },
            },
          },

          "create corrective action": {
            invoke: {
              src: "createCorrectiveAction",
              id: "create-corrective-action",
              onDone: {
                target: "success",
                actions: ["saveCorrectiveAction", "flagChanges"],
              },
              onError: "error",
            },
          },

          error: {
            on: {
              RETRY: "create corrective action",
              CLOSE: "#create-corrective-action.idle",
            },
          },

          "confirm abandon": {
            on: {
              CANCEL_ABANDON: "edit corrective action",
              CONFIRM_ABANDON: "#create-corrective-action.idle",
            },
          },

          success: {
            final: true,
            type: "final",

            on: {
              CLOSE: "#create-corrective-action.idle",
            },
          },
        },
        initial: "edit corrective action",
      },
    },

    initial: "idle",
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { CreateCorrectiveActionMachine };
